import { ClientBySearch } from '../interfaces/ClientBySearch';
import { getClientsBySearch } from './api/clientsBySearch';
import globalErrorHandler from './globalErrorHandler';

const getClientIDs = async (freeText: string) => {
    try {
        const result = await getClientsBySearch({ freeText });
        const { clients } = result;
        return clients.map((client: ClientBySearch) => client.client);
    } catch (error) {
        globalErrorHandler(error);
    }
};

export { getClientIDs };
